const getDefaultState = () => {
  return {
    data: {
      eledate: [],
      mark: [],
    },
  }
}

const getters = {
}

const actions = {
  setListEledate({ commit }, data) {
    commit('SET_ELEDATE', data)
  },
  setListMark({ commit }, data) {
    commit('SET_MARK', data)
  },
  resetListData({ commit }) {
    commit('RESET_DATA')
  },
}

const mutations = {
  SET_ELEDATE(state, data) {
    state.data.eledate = data
  },
  SET_MARK(state, data) {
    state.data.mark = data
  },
  RESET_DATA(state) {
    Object.assign(state, getDefaultState())
  },
}

const state = getDefaultState()

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
